import React from 'react'
import RenderSpan from './RenderSpan'

const StatusCellNoEdit = ({ cell, row, rowIndex }) => {
  const selectedOptions = {
    0: 'Active',
    1: 'Inactive',
    2: 'Ignored',
  }

  return (
    <span>
      <RenderSpan rowIndex={rowIndex} option={selectedOptions[cell]} ignoreReason={row.ignoreReason} />{' '}
    </span>
  )
}

export default StatusCellNoEdit
